import { render, staticRenderFns } from "./DocTypeShow.vue?vue&type=template&id=8f06c5ba&"
import script from "./DocTypeShow.vue?vue&type=script&lang=js&"
export * from "./DocTypeShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports